import { useTerminalsState } from "@/States/Terminals";
import { UNIT_LABELS } from "@/pages/reporting_v2/constants";
import { ReportingPageContext } from "@/pages/reporting_v2/context";
import {
  REPORTING_TAB_TYPES,
  REPORTING_VIEW_TYPES,
} from "@/pages/reporting_v2/types";
import { useTrans } from "@/translations";

import { useContext, useMemo } from "react";

import { ReportingTableContext } from "../../../context";
import type { ReportingTableHeader, TableRow } from "../../../types";
import type { StickyPosition } from "../utils";
import { ReportingTableTotalsCell } from "./totalsCell";

type Props = {
  headers: ReportingTableHeader[];
  totalsRow: TableRow;
  stickyPositions: Record<string, StickyPosition>;
};

export const ReportingTableTotalsRow: React.FC<Props> = ({
  headers,
  totalsRow,
  stickyPositions,
}) => {
  const { t } = useTrans();
  const { viewType, tabType } = useContext(ReportingPageContext);
  const { unit } = useContext(ReportingTableContext);
  const { currentTerminal } = useTerminalsState();

  const isIndividualTab = tabType === REPORTING_TAB_TYPES.INDIVIDUAL;

  const label = useMemo(() => {
    if (!isIndividualTab) return t("reportingPage:reportingTotal");
    const scope =
      viewType === REPORTING_VIEW_TYPES.PORTFOLIO
        ? t("reportingPage:viewTypePortfolioLabel")
        : currentTerminal?.name;
    return t("reportingPage:totalWithUnit", { scope, unit: UNIT_LABELS[unit] });
  }, [isIndividualTab, viewType, currentTerminal?.name, unit, t]);

  return (
    <tr>
      {headers.map((header) => (
        <ReportingTableTotalsCell
          key={header.id}
          columnId={header.id}
          totalsRow={totalsRow}
          label={label}
          isIndividualTab={isIndividualTab}
          stickyPosition={stickyPositions[header.id]}
        />
      ))}
    </tr>
  );
};
